/**
 * The evidence a company uploads to be reclassified Korporat → UMKM.
 *
 * ⚠️ NOT RATIFIED. These two documents come from Figma 15557:26980 and appear
 * NOWHERE in the BRD or the backend — OPEN-0009 ("Isi & kriteria bukti
 * verifikasi golongan UMKM") is still open with the business team. The backend
 * deliberately accepts evidence by the `umkm_` PREFIX rather than an enumerated
 * list for exactly this reason (company.controller.js uploadDocument), so this
 * array is the single place to change when the answer lands — no migration, no
 * backend edit, no enum to keep in sync.
 *
 * The prefix is load-bearing beyond validation: `company_documents` is shared
 * with the CLIK enrolment documents, and the SAW membership reviewer filters
 * `umkm_*` out of its attachments card so the two reviews stay separate
 * (BR-COMPANY-04 poin 2.6). Every key here MUST keep the prefix.
 */
export const UMKM_EVIDENCE = [
  {
    key: 'umkm_ikhtisar_profil_wajib_pajak',
    label: 'Taxpayer profile summary (Ikhtisar Profil Wajib Pajak)',
    required: true,
    howTo: [
      'Log in to Coretax at https://coretaxdjp.pajak.go.id with your NIK/User ID and password.',
      'Once logged in, click the "Portal Saya" (My Portal) menu in the navigation panel.',
      'Click the "Ikhtisar Profil Wajib Pajak" (Taxpayer Profile Summary) sub-menu.',
      'Take a screenshot or download the profile summary as a PDF.',
    ],
  },
  {
    key: 'umkm_surat_keterangan_non_pkp',
    label: 'Non-PKP statement letter (Surat keterangan non PKP)',
    required: true,
    note: 'The statement letter must bear a duty stamp (materai).',
  },
]

// Figma states "PDF of JPG (max. 10MB)". The cap is taken from the BACKEND,
// which is the thing that actually rejects: core/helpers/upload.js
// companyDocumentUpload = maxSizeMB 10. PNG is added to the design's list on
// purpose — step 4 of the how-to tells the user to SCREENSHOT the page, and
// both Windows and macOS produce PNG. The backend already accepts it.
export const ACCEPTED_EXTENSIONS = ['.pdf', '.jpg', '.jpeg', '.png']
export const MAX_SIZE_BYTES = 10 * 1024 * 1024
export const ACCEPTED_LABEL = 'PDF, JPG or PNG (max. 10MB)'
